/**
 * Popup close button — brand X extracted from the Figma design.
 * 50px circle, white fill, 2px credits-red ring, black brand X glyph.
 */

import React from "react";

interface CloseButtonProps {
    onClose: () => void;
    /** Rendered square size in px. Design sizes: mobile 40, tablet 44, desktop 50. */
    size?: number;
    className?: string;
}

export function CloseButton({onClose, size = 50, className = ""}: CloseButtonProps) {
    return (
        <button
            type="button"
            onClick={onClose}
            aria-label="Schliessen"
            className={`group inline-flex shrink-0 items-center justify-center rounded-full transition hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-credits focus-visible:ring-offset-2 active:scale-95 ${className}`}
            style={{width: size, height: size}}
        >
            <svg width={size} height={size} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <rect x="1" y="1" width="48" height="48" rx="24" fill="white" />
                <rect x="1" y="1" width="48" height="48" rx="24" stroke="#C20016" strokeWidth="2" />
                <path d="M27.86 32.04L25 27.74L22.48 32.04H18.6L23.1 24.9L18.5 18H22.48L25.3 22.24L27.78 18H31.66L27.2 25.08L31.84 32.04H27.86Z" fill="black" />
            </svg>
        </button>
    );
}
